import { render, staticRenderFns } from "./grandstream_on_premise.vue?vue&type=template&id=38f5a65e&scoped=true&"
import script from "./grandstream_on_premise.vue?vue&type=script&lang=js&"
export * from "./grandstream_on_premise.vue?vue&type=script&lang=js&"
import style0 from "./grandstream_on_premise.vue?vue&type=style&index=0&id=38f5a65e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5a65e",
  null
  
)

export default component.exports